// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"6d7de513","992":"b1e8673c"}[chunkId] + ".chunk.js";
};